<template>
  <div class="sidebar mb-3">
    <router-link to="/produtos" :class="{ ativo: isActive[0] }">
      <svg
        width="25"
        height="25"
        viewBox="0 0 24 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="icones_fill"
          d="M16.8 13.1969H16.9802V13.0167V10.65V10.4698H16.8H7.2H7.01976V10.65V13.0167V13.1969H7.2H16.8ZM0.180245 0.180245H23.8198V4.55309H0.180245V0.180245ZM20.4 6.09691H22.6198V18.9333C22.6198 19.5124 22.3865 20.0682 21.9705 20.4785C21.5544 20.8888 20.9895 21.1198 20.4 21.1198H3.6C3.01048 21.1198 2.4456 20.8888 2.0295 20.4785C1.61349 20.0682 1.38024 19.5124 1.38024 18.9333V6.09691H20.4Z"
          fill="#2C2C2C"
          stroke="black"
          stroke-width="0.360489"
        />
      </svg>
      <span class="abas_text">Produtos</span>
    </router-link>

    <router-link to="/casas" :class="{ ativo: isActive[1] }">
      <svg
        width="25"
        height="25"
        viewBox="0 0 30 30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            id="Vector"
            d="M15 1.12909L1.50222 14.6272L1.12915 15L1.87505 15.7459L2.24788 15.3728L15 2.62071L27.7522 15.3728L28.125 15.7459L28.8709 15L28.4979 14.6272L15 1.12909ZM5.62505 2.81249V9.09801L9.37505 5.3479V2.81249H5.62505ZM15 4.02696L3.75005 15.277V28.4766H7.50005V18.75H13.125V28.4766H26.25V15.277L15 4.02696ZM16.875 18.75H22.5V23.4375H16.875V18.75Z"
            fill="#2c2c2c"
            stroke="black"
            stroke-width="0.43997"
          />
        </g>
      </svg>
      <span class="abas_text">Casas</span>
    </router-link>

    <router-link to="/colheita" :class="{ ativo: isActive[2] }">
      <svg
        width="25"
        height="25"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="icones_fill"
          d="M9.33333 4.96871H9.11335V5.18869V7.63314V7.85312H9.33333H20H20.22V7.63314V5.18869V4.96871H20H9.33333ZM9.33333 9.8576H9.11335V10.0776V12.522V12.742H9.33333H20H20.22V12.522V10.0776V9.8576H20H9.33333ZM9.33333 14.7465H9.11335V14.9665V17.4109V17.6309H9.33333H20H20.22V17.4109V14.9665V14.7465H20H9.33333ZM4 4.96871H3.78001V5.18869V7.63314V7.85312H4H6.66667H6.88665V7.63314V5.18869V4.96871H6.66667H4ZM4 9.8576H3.78001V10.0776V12.522V12.742H4H6.66667H6.88665V12.522V10.0776V9.8576H6.66667H4ZM4 14.7465H3.78001V14.9665V17.4109V17.6309H4H6.66667H6.88665V17.4109V14.9665V14.7465H6.66667H4ZM0.219985 19.8554V2.74425C0.219985 2.16077 0.472671 1.59687 0.929698 1.17793C1.38736 0.7584 2.01189 0.51979 2.66667 0.51979H21.3333C21.9881 0.51979 22.6126 0.7584 23.0703 1.17793C23.5273 1.59687 23.78 2.16077 23.78 2.74425V19.8554C23.78 20.4388 23.5273 21.0027 23.0703 21.4217C22.6126 21.8412 21.9881 22.0798 21.3333 22.0798H2.66667C2.01189 22.0798 1.38737 21.8412 0.929698 21.4217C0.472671 21.0027 0.219985 20.4388 0.219985 19.8554Z"
          fill="#2C2C2C"
          stroke="black"
          stroke-width="0.43997"
        />
      </svg>
      <span class="abas_text">Colheita</span>
    </router-link>

    <router-link to="/clientes" :class="{ ativo: isActive[3] }">
      <svg
        width="25"
        height="25"
        viewBox="0 0 28 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="icones_fill"
          d="M21.8166 10.2998V10.1196H21.6364H17.9984V7.98005H21.6364H21.8166V7.7998V4.23005H24.0016V7.7998V7.98005H24.1818H27.8198V10.1196H24.1818H24.0016V10.2998V13.8696H21.8166V10.2998ZM10.1818 0.480049C12.8981 0.480049 15.0925 2.6399 15.0925 5.2998C15.0925 7.95971 12.8981 10.1196 10.1818 10.1196C7.46556 10.1196 5.27115 7.95971 5.27115 5.2998C5.27115 2.6399 7.46556 0.480049 10.1818 0.480049ZM20.1834 20.1196H0.180245V17.7998C0.180245 17.036 0.568377 16.3528 1.23409 15.7494C1.9009 15.1449 2.83305 14.6336 3.88258 14.2207C5.9818 13.3947 8.50483 12.98 10.1818 12.98C11.8588 12.98 14.3818 13.3947 16.4811 14.2207C17.5306 14.6336 18.4627 15.1449 19.1295 15.7494C19.7953 16.3528 20.1834 17.036 20.1834 17.7998V20.1196Z"
          fill="#2C2C2C"
          stroke="black"
          stroke-width="0.360489"
        />
      </svg>

      <span class="abas_text">Clientes</span>
    </router-link>

    <router-link to="/vendas" :class="{ ativo: isActive[4] }">
      <svg
        width="25"
        height="25"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="icones_fill"
          d="M3.99374 2.11939L3.99366 2.11943C3.8545 2.18564 3.7247 2.25071 3.60358 2.31347L3.99374 2.11939ZM3.99374 2.11939C5.54183 1.38189 8.15837 0.480049 11.0245 0.480049C13.8365 0.480049 16.3897 1.34852 17.9291 2.078L17.9306 2.07869C18.2396 2.22164 18.5403 2.37995 18.8316 2.55294L17.2889 4.69841L16.3805 5.14701C16.3802 5.14715 16.3799 5.1473 16.3796 5.14744C13.1555 6.69464 8.82435 6.69449 5.60111 5.14701L5.59416 5.14367M3.99374 2.11939L5.59416 5.14367M5.59416 5.14367L5.58695 5.14094L4.80058 4.84311L3.16624 2.55347M5.59416 5.14367L3.16624 2.55347M3.16624 2.55347C3.29334 2.47902 3.43972 2.39844 3.60352 2.3135L3.16624 2.55347ZM4.95328 2.50998L4.49317 2.70442L4.97142 2.84858C5.58913 3.03477 6.21814 3.18498 6.85498 3.29838L6.85535 3.29845C8.25572 3.54484 9.6813 3.58373 10.9112 3.24521C12.4229 2.82959 14.0082 2.49221 15.4921 2.29361L15.5221 1.94297C14.235 1.53923 12.6758 1.21965 11.0239 1.21965C8.64067 1.21965 6.43262 1.88478 4.95328 2.50998ZM17.0574 6.45413L17.0576 6.45403L17.0983 6.43443C18.3954 7.7706 19.6182 9.40715 20.4945 11.1133C21.3921 12.861 21.9187 14.6671 21.8042 16.2913C21.6905 17.9052 20.9441 19.3512 19.2659 20.4012C17.578 21.4573 14.9359 22.1196 11.0245 22.1196C7.1125 22.1196 4.46319 21.4694 2.76595 20.4278C1.07856 19.3924 0.321799 17.9644 0.198499 16.3637C0.0743726 14.7524 0.592079 12.9531 1.48641 11.1965C2.3595 9.48161 3.58436 7.82164 4.89247 6.43906L4.92308 6.45388L4.92361 6.45413C8.57395 8.20616 13.407 8.20616 17.0574 6.45413ZM10.1764 15.1423V17.2182C10.0107 17.1923 9.85299 17.1311 9.7155 17.0386C9.52893 16.9131 9.38934 16.7368 9.31429 16.5349C9.2402 16.3353 9.08697 16.1747 8.89136 16.0857C8.69594 15.9968 8.47216 15.9855 8.26842 16.054C8.06452 16.1225 7.8948 16.2663 7.79917 16.4566C7.70334 16.6474 7.69089 16.8674 7.76509 17.0674L7.76512 17.0675C7.95581 17.5806 8.30834 18.0232 8.77254 18.3355C9.18727 18.6146 9.67332 18.7777 10.1764 18.8093V19.2458V19.4261H10.3566H11.6411H11.8213V19.2458V18.8093C12.4821 18.7678 13.1085 18.4996 13.5819 18.0492C14.0984 17.5577 14.3903 16.8891 14.3903 16.19C14.3903 15.4909 14.0984 14.8223 13.5819 14.3308C13.1085 13.8804 12.4821 13.6122 11.8213 13.5708V11.4947C12.2248 11.5571 12.5514 11.8252 12.6832 12.176C12.7176 12.2765 12.7725 12.3689 12.8441 12.448C12.9164 12.5279 13.0044 12.5927 13.1024 12.6389C13.2005 12.6851 13.3069 12.712 13.4154 12.7182C13.524 12.7245 13.6329 12.7099 13.7358 12.6753C13.8387 12.6407 13.9338 12.5867 14.0153 12.5159C14.0968 12.4451 14.1632 12.359 14.21 12.2624C14.2567 12.1657 14.2829 12.0607 14.2864 11.9537C14.29 11.8475 14.2713 11.742 14.2317 11.6432C14.0408 11.1311 13.6886 10.6894 13.2251 10.3775C12.8104 10.0985 12.3244 9.93535 11.8213 9.9038V9.46723V9.28699H11.6411H10.3566H10.1764V9.46723V9.9038C9.51558 9.94522 8.88915 10.2134 8.41582 10.6638C7.89933 11.1553 7.6074 11.8239 7.6074 12.523C7.6074 13.2222 7.89933 13.8907 8.41582 14.3822C8.88915 14.8327 9.51558 15.1009 10.1764 15.1423ZM9.57259 11.7893C9.73658 11.6333 9.94812 11.5306 10.1764 11.4949V13.5512C9.94812 13.5155 9.73658 13.4128 9.57259 13.2568C9.36642 13.0606 9.25237 12.7965 9.25237 12.523C9.25237 12.2496 9.36642 11.9855 9.57259 11.7893ZM12.4251 16.9238C12.2611 17.0798 12.0496 17.1825 11.8213 17.2181V15.1619C12.0496 15.1976 12.2611 15.3002 12.4251 15.4563C12.6313 15.6525 12.7453 15.9166 12.7453 16.19C12.7453 16.4634 12.6313 16.7276 12.4251 16.9238Z"
          fill="#2C2C2C"
          stroke="black"
          stroke-width="0.360489"
        />
      </svg>

      <span class="abas_text">Vendas</span>
    </router-link>

    <router-link to="/composto" :class="{ ativo: isActive[5] }">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="icones_fill"
          d="M14.0116 1.10697L18.4232 5.51701L12.5 11.4402L6.5783 5.51699L10.9868 1.10694C10.9868 1.10694 10.9868 1.10693 10.9868 1.10692C11.8062 0.287606 13.124 0.271418 13.963 1.05836L14.0116 1.10697ZM24.1944 14.3114L24.1944 14.3114L19.7844 18.723L13.8611 12.7998L19.7828 6.87508L24.1944 11.2882L24.1945 11.2883C25.0302 12.1225 25.0303 13.4755 24.1944 14.3114ZM10.9884 24.4942L10.9884 24.4942L6.5768 20.0842L12.5 14.1609L18.4247 20.0826L14.0116 24.4942L14.0115 24.4943C13.1773 25.33 11.8243 25.3302 10.9884 24.4942ZM0.80714 11.2882L0.807162 11.2882L5.21719 6.87662L11.1389 12.7998L5.21796 18.7238L0.807162 14.3114L0.80703 14.3113C-0.0286229 13.4771 -0.0287812 12.1241 0.80714 11.2882Z"
          fill="#2C2C2C"
          stroke="black"
          stroke-width="0.360489"
        />
      </svg>

      <span class="abas_text">Composto</span>
    </router-link>

    <router-link to="/configuracoes" :class="{ ativo: isActive[6] }">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="icones_fill"
          d="M21.6561 10.1354L21.6938 10.267L21.825 10.3061L24.6035 11.1347C24.6475 11.1559 24.6846 11.189 24.7105 11.2303C24.7385 11.275 24.7522 11.3271 24.7497 11.3797L24.7494 11.3797V11.3915L24.7494 14.232C24.7494 14.2321 24.7494 14.2323 24.7494 14.2324C24.7491 14.2872 24.7313 14.3405 24.6986 14.3846C24.666 14.4285 24.6204 14.4609 24.5682 14.4773C24.5678 14.4774 24.5674 14.4775 24.567 14.4776L21.7586 15.3102L21.6283 15.3488L21.5899 15.4792C21.3996 16.1245 21.1408 16.7478 20.8179 17.3382L20.7529 17.457L20.8169 17.5763L22.2012 20.1588C22.2012 20.1589 22.2013 20.1591 22.2013 20.1592C22.2273 20.2081 22.2368 20.2641 22.2284 20.3189C22.22 20.3738 22.1941 20.4245 22.1545 20.4636L22.1535 20.4646L20.1598 22.4563L20.1588 22.4573C20.1197 22.4969 20.0688 22.5228 20.0137 22.5312C19.9587 22.5396 19.9024 22.5301 19.8532 22.504C19.8532 22.504 19.8532 22.504 19.8531 22.504L17.2594 21.1209L17.1408 21.0576L17.0226 21.1217C16.4338 21.441 15.8127 21.6968 15.1697 21.8849L15.0389 21.9231L15.0002 22.0538L14.1669 24.8676C14.1668 24.868 14.1666 24.8684 14.1665 24.8688C14.1502 24.9209 14.1177 24.9664 14.0738 24.9989C14.0296 25.0316 13.9762 25.0495 13.9211 25.0498C13.921 25.0498 13.9209 25.0498 13.9208 25.0498H11.1037C11.1036 25.0498 11.1034 25.0498 11.1033 25.0498C11.0483 25.0495 10.9948 25.0316 10.9506 24.9989C10.9067 24.9664 10.8743 24.9208 10.8579 24.8688C10.8578 24.8684 10.8577 24.868 10.8576 24.8676L10.0242 22.062L9.98527 21.9309L9.85386 21.893C9.20533 21.7058 8.5787 21.45 7.98465 21.1298L7.86664 21.0661L7.74835 21.1292L5.17134 22.504C5.12215 22.5301 5.06582 22.5396 5.01073 22.5312C4.95564 22.5228 4.90477 22.4969 4.86566 22.4573L4.8646 22.4563L2.87099 20.4646L2.86993 20.4636C2.83035 20.4245 2.80446 20.3738 2.79607 20.3189C2.78768 20.264 2.79722 20.2079 2.8233 20.1588L2.82409 20.1573L4.1921 17.5407L4.25514 17.4201L4.1881 17.3017C3.84898 16.7027 3.57649 16.0684 3.3755 15.4102L3.33642 15.2822L3.20824 15.2437L0.432386 14.411C0.432141 14.4109 0.431896 14.4108 0.431652 14.4107C0.37927 14.3944 0.333468 14.3619 0.300833 14.3179C0.268146 14.2739 0.250358 14.2206 0.25 14.1658V11.3506C0.250358 11.2958 0.268146 11.2425 0.300833 11.1985C0.333493 11.1545 0.37934 11.1219 0.431773 11.1056C0.431977 11.1056 0.432181 11.1055 0.432386 11.1054L3.19195 10.2726L3.32099 10.2336L3.35937 10.1044C3.55819 9.43502 3.83073 8.78973 4.17199 8.18038L4.2392 8.06036L4.17379 7.93935L2.82329 5.4409C2.82318 5.44068 2.82307 5.44047 2.82295 5.44025C2.79714 5.39135 2.78772 5.33548 2.79607 5.28085C2.80443 5.22621 2.83013 5.17566 2.86943 5.13665C2.8696 5.13649 2.86976 5.13632 2.86993 5.13616L4.89575 3.16231L4.89578 3.16234L4.89902 3.15906C4.93814 3.11951 4.98901 3.09359 5.0441 3.08518C5.09895 3.07681 5.15502 3.08625 5.20406 3.11209C5.20428 3.1122 5.20449 3.11232 5.20471 3.11243L7.70562 4.4616L7.82629 4.5267L7.94604 4.45994C8.5586 4.11845 9.20731 3.84615 9.88018 3.64807L10.0096 3.60996L10.0488 3.48082L10.8826 0.732098C10.8826 0.731915 10.8827 0.731732 10.8828 0.731548C10.899 0.679273 10.9316 0.633475 10.9757 0.600807C11.0198 0.568119 11.0732 0.550291 11.1282 0.549932H13.947V0.549995L13.9526 0.54987C14.0074 0.548642 14.0612 0.564828 14.1062 0.596063C14.15 0.626495 14.1833 0.669671 14.2015 0.719613L15.034 3.47228L15.0729 3.60102L15.2018 3.63948C15.8691 3.83861 16.5123 4.11089 17.1196 4.45132L17.2389 4.5182L17.3596 4.45378L19.9032 3.09577C19.9032 3.09575 19.9032 3.09573 19.9033 3.09571C19.9524 3.06965 20.0087 3.06011 20.0638 3.06851C20.1189 3.07692 20.1697 3.10284 20.2088 3.14239L20.2095 3.14308L22.2031 5.14307L22.2046 5.14449C22.2442 5.18357 22.27 5.23431 22.2784 5.28918C22.2868 5.34406 22.2773 5.40018 22.2512 5.44923L20.8835 8.00701L20.8201 8.12556L20.8841 8.24382C21.209 8.84467 21.4679 9.47891 21.6561 10.1354ZM9.8496 16.8187C10.6452 17.3497 11.5805 17.6332 12.5373 17.6332C13.8202 17.6332 15.0507 17.124 15.958 16.2176C16.8653 15.3112 17.3751 14.0818 17.3751 12.7999C17.3751 11.8439 17.0913 10.9094 16.5597 10.1145C16.0281 9.31969 15.2725 8.70023 14.3885 8.33444C13.5046 7.96865 12.5319 7.87295 11.5935 8.05942C10.6551 8.2459 9.79308 8.70618 9.11648 9.38212C8.43989 10.0581 7.97909 10.9193 7.7924 11.8569C7.60571 12.7945 7.70153 13.7664 8.06773 14.6496C8.43392 15.5328 9.05403 16.2876 9.8496 16.8187Z"
          fill="#2C2C2C"
          stroke="black"
          stroke-width="0.5"
        />
      </svg>

      <span class="abas_text">Configurações</span>
    </router-link>

    <div @click="logout()">
      <svg
        width="25"
        height="25"
        viewBox="0 0 27 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0929 6.49604V4.24802C10.0929 3.65181 10.3297 3.08001 10.7513 2.65843C11.1729 2.23684 11.7447 2 12.3409 2H23.1314C23.7276 2 24.2994 2.23684 24.721 2.65843C25.1426 3.08001 25.3794 3.65181 25.3794 4.24802V17.7361C25.3794 18.3323 25.1426 18.9041 24.721 19.3257C24.2994 19.7473 23.7276 19.9841 23.1314 19.9841H12.3409C11.7447 19.9841 11.1729 19.7473 10.7513 19.3257C10.3297 18.9041 10.0929 18.3323 10.0929 17.7361V15.4881M6.49604 6.49604L2 10.9921M2 10.9921L6.49604 15.4881M2 10.9921H17.3427"
          stroke="#2C2C2C"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="abas_text">Sair</span>
    </div>
  </div>
</template>

<script>
import { RemoveCookie } from '../utils/Cookie';

export default {
  data() {
    return {
      isActive: [0, 0, 0, 0, 0, 0, 0],
    };
  },
  created() {
    this.optionChange(this.$route.path);
  },
  methods: {
    logout() {
      RemoveCookie('token');
      localStorage.removeItem('__cogumelos_umami_user');
      this.$router.push('/');
    },
    optionChange(route) {
      this.isActive = [0, 0, 0, 0, 0, 0, 0];
      switch (route) {
        case '/produtos':
          this.isActive[0] = 1;
          break;
        case '/casas':
          this.isActive[1] = 1;
          break;
        case '/colheita':
          this.isActive[2] = 1;
          break;
        case '/clientes':
          this.isActive[3] = 1;
          break;
        case '/vendas':
          this.isActive[4] = 1;
          break;
        case '/composto':
          this.isActive[5] = 1;
          break;
        case '/configuracoes':
          this.isActive[6] = 1;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.sidebar {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #2c2c2c;
  border-bottom: 1px solid #2c2c2c;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
}

.sidebar a,
.sidebar div {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2c2c2c;
  padding: 16px;
  text-decoration: none;
  height: 12.5%;
}

.ativo .abas_text {
  color: #9a5c28;
  font-weight: 900;
}

.ativo .icones_fill {
  fill: #9a5c28 !important;
}

.sidebar a:hover:not(.router-link-active),
.sidebar div:hover {
  background-color: #be8250;
  color: white;
}

.sidebar div {
  cursor: pointer;
}

img {
  height: 22px;
  width: 24px;
}

@media (min-width: 720px) {
  .sidebar {
    display: inline;
    border-bottom: none;
  }
}
</style>
